import moment from 'moment'
import React from 'react'
import { IoChevronForward } from 'react-icons/io5'
import { invoiceCardStatus } from '../../../utils/enums/cardEnums'
import { pluralize } from '../../../utils/pluralize'

const InvoiceItem = ({ onInvoiceClick, invoice }) => {
  const authorizedTransactionsCount = invoice.invoiceTransactions?.filter(
    ({ status }) => status === 'AUTHORIZED'
  ).length ?? 0;

  return (
    <div className={`fatura-card ${invoice.status.toLocaleLowerCase()}`} key={invoice.id} onClick={() => onInvoiceClick(invoice)}>
      <div className="fatura-info">
        <div className="fatura-mes">
          {moment(invoice.dueDate).format('MMMM').toLocaleUpperCase()}
          <span className={`status-tag status-${invoice.status.toLocaleLowerCase()}`}>{invoiceCardStatus[invoice.status]}</span>
        </div>
        <div className="fatura-valor">{Number(invoice.totalAmount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
        <div className="fatura-detalhes">
          <div><i>📅</i> Vence em {moment(invoice.dueDate).format('DD/MM/YYYY')}</div>
          <div><i>💳</i>{pluralize(authorizedTransactionsCount, "compra", "compras")}</div>
        </div>
      </div>
      <IoChevronForward className="card-arrow col-md-1" />
    </div>
  )
}

export default InvoiceItem
